// Setas da galeria no computador: ativam a miniatura anterior/seguinte,
// reaproveitando a troca de mídia que o tema já faz no clique da miniatura.
document.addEventListener('click', (event) => {
  const arrow = event.target.closest('.gallery-arrow');
  if (!arrow) return;

  const gallery = arrow.closest('media-gallery');
  if (!gallery) return;

  const thumbnails = Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'))
    .filter((thumbnail) => thumbnail.offsetParent !== null);
  if (thumbnails.length < 2) return;

  const current = Math.max(thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')), 0);
  const step = arrow.name === 'gallery-next' ? 1 : -1;
  const target = thumbnails[(current + step + thumbnails.length) % thumbnails.length];
  target.querySelector('button').click();
});
